(function($) {

    $('#navbarToggle').on('click', function() {
        var primaryNavigation = $('#primaryNavigation');

        // Dropdown toggle setup
        if(primaryNavigation.hasClass('is-active')) {
            primaryNavigation.removeClass('is-active');
            $('body').removeClass('no-scroll');

        } else {
            primaryNavigation.addClass('is-active');
            $('body').addClass('no-scroll');

            setTimeout(function() {
                $('#navbarClose').addClass('is-active');
            }, 600);

        }
    });

    // Dropdown close button
    $('#navbarClose').on('click', function() {
        $('#primaryNavigation').removeClass('is-active');
        $('body').removeClass('no-scroll');
    });

    // Dropdown back button
    $('.navbar-back').on('click', function() {
        $(this)
            .closest('.dropdown-menu')
            .removeClass('show')
    });

    // Prevents dropdown from closing when clicking outside of a link
    $('.dropdown-menu').on('click', function(e) {
        e.stopPropagation();
    });

    //
    $('.primary-navbar .nav-link').on('click', function() {
        $('#navbarClose').removeClass('is-active');

        setTimeout(function() {
            $('#navbarClose').addClass('is-active');
        }, 600);
    });

})(jQuery);
